import { Flex, Typography } from 'antd'
import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

import type { MutableWorkspaceRole } from 'src/utils/workspaceAuthorization'

import { EmailInviteForm, type EmailInviteFormHandle } from './EmailInviteForm'
import type { PendingInvite } from './types'

type InviteMembersStepProps = {
  invites: PendingInvite[]
  addInvite: (email: string, orgRole: MutableWorkspaceRole) => void
  removeInvite: (inviteId: string) => void
  updateInviteRole?: (inviteId: string, orgRole: MutableWorkspaceRole) => void
}

export const InviteMembersStep = forwardRef<
  EmailInviteFormHandle,
  InviteMembersStepProps
>(({ invites, addInvite, removeInvite, updateInviteRole }, ref) => {
  const { t } = useTranslation()

  return (
    <Flex orientation="vertical" gap={16}>
      <Flex orientation="vertical" gap={4} align="center">
        <Typography.Title level={5} style={{ marginBottom: 0 }}>
          {t('workspaces.create.invite.title')}
        </Typography.Title>
        <Typography.Text type="secondary" style={{ fontSize: 13 }}>
          {t('workspaces.create.invite.description')}
        </Typography.Text>
      </Flex>

      <EmailInviteForm
        ref={ref}
        invites={invites}
        onAdd={addInvite}
        onRemove={removeInvite}
        onUpdateRole={updateInviteRole}
      />
    </Flex>
  )
})

InviteMembersStep.displayName = 'InviteMembersStep'
